// extracted by mini-css-extract-plugin
export default {"zoomControls":"Rea-z","zoomControlButton":"Sea-z","zoomBanner":"Tea-z","bannerButton":"Uea-z","imageButton":"Vea-z","zoom":"Wea-z","zoomContent":"Xea-z"};